import React, { Component } from "react";
import Autocomplete from "react-autocomplete";
import NumberCircle from "../elements/NumberCircle";
import RangeInput from "../elements/RangeInput";

class LocationInput extends Component {
  render() {
    if (this.props.focus) {
      this.input.focus();
    }
    return (
      <div className="location-filter menu--tab">
        <div className="menu--header">Enter an address, city, region, etc. A radius of 10km is automatically set</div>
        <div className="location-input input-container autocomplete">
          <Autocomplete
            ref={ref => this.input = ref}
            getItemValue={item => item.formatted_address}
            items={this.props.locations}
            renderItem={(item, isHighlighted) => (
              <div
                key={item.formatted_address}
                className="suggestion"
                style={{ background: isHighlighted ? "lightgray" : "white" }}
              >
                {item.formatted_address}
              </div>
            )}
            autoHighlight={true}
            inputProps={{
              tabIndex: this.props.tabIndex,
              placeholder: "e.g. Copenhagen",
              onBlur: e => {
                if (this.props.locations.length > 0) {
                  this.props.selectLocation(this.props.locations[0], false);
                }
              }
            }}
            value={this.props.value}
            onChange={e => this.props.onChange(e.target.value)}
            onSelect={(val, item) => this.props.selectLocation(item, true)}
          />
        </div>
        {this.props.isGruvi ? <div className="flex-row space-between align-center  margin-top-small">
          <div className="menu--header">Distance Radius</div>
          <NumberCircle>{this.props.distance}</NumberCircle>
        </div>: <div></div>}
        {this.props.isGruvi ?<RangeInput
          min={1}
          max={50}
          value={this.props.distance}
          onChanged={value => {
            this.props.handleDistanceChange(value);
          }}
        /> : <div></div>}
      </div>
    );
  }
}

export default LocationInput;



// WEBPACK FOOTER //
// ./src/components/LocationInput.js